export class Module {
  name: string;
  nc12: string;
  id: number;
  image: string;
  sortOrder: number;

  capabilities: any;

  isVisible: string;
  isVisibleNa: string;
  isVisibleSa: string;
  isVisibleCn: string;
  isVisibleRoa: string;

  isInMaintenanceMode: string;
  isInMaintenanceModeNa: string;
  isInMaintenanceModeSa: string;
  isInMaintenanceModeCn: string;
  isInMaintenanceModeRoa: string;

  viewStatus: string;
  viewStatusNa: string;
  viewStatusSa: string;
  viewStatusCn: string;
  viewStatusRoa: string;

  description: string;
  descriptionNa: string;
  descriptionSa: string;
  descriptionCn: string;
  descriptionRoa: string;

  driverFamilyIdEMEA: string;
  driverFamilyIdNA: string;
  driverFamilyIdSA: string;
  driverFamilyIdCN: string;
  driverFamilyIdROA: string;

  family: Object;
  housing: any;

  phaseIn: string;
  phaseInNa: string;
  phaseInSa: string;
  phaseInCn: string;
  phaseInRoa: string;

  phaseOut: string;
  phaseOutNa: string;
  phaseOutSa: string;
  phaseOutCn: string;
  phaseOutRoa: string;

  datasheetUrl: string;
  datasheetUrlNa: string;
  datasheetUrlSa: string;
  datasheetUrlCn: string;
  datasheetUrlRoa: string;

  driversWhitelist: any;

  boxQuantity: number;
}





// WEBPACK FOOTER //
// ./src/app/_models/module.ts